var e = { field: {
	emailRequired: "Email is required",
	emailInvalid: "Enter a valid email address",
	fieldRequired: "This field is required",
	passwordMinLength: "Use at least {{min}} characters",
	otpLength: "Enter the {{length}}-digit code",
	ratingRequired: "Please add a rating",
	dateRangeRequired: "Select your dates",
	discountPositive: "Enter a discount greater than 0",
	percentageMax: "A percentage cannot exceed 100",
	currencyRequired: "Choose a currency",
	weekdaysRequired: "Choose at least one day",
	startTimesRequired: "Add a start time",
	timeInvalid: "Enter a time",
	horizonMin: "Enter a whole number of days",
	horizonMax: "Open sessions at most {{max}} days ahead",
	phoneRequired: "Phone number is required",
	phoneInvalid: "Enter a valid phone number"
} };
//#endregion
export { e as default };
